import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { httpClient } from 'redux/reducers/settings';
import { api } from './service-api';

export interface TMSSecondaryResponse<T = any> {
  results: T;
  status: 0 | 1;
  message: string;
}

interface IDiscussionData {
  sessionId: string;
  courseTitle: string;
  discussionDetail: { content?: string };
}

interface IDiscussionReplyData {
  sessionId: string;
  courseTitle: string;
  parentId: string | number;
  replyDetail: { user?: number; content?: string };
}
export interface IPageQueryParams {
  page?: number | void;
  pageSize?: number | void;
}

export interface ISessionData {
  sessionId?: string | void;
  courseTitle?: string | void;
}

export interface IDiscussionResponse {
  attachment: {
    name: string;
    type: string;
    url: string;
  };
  content: string;
  edited: string;
  id: number | string;
  parent: number;
  posted: string;
  replies: IReplyResponse[];
  reply_count: number;
  urlhash: string;
  user: {
    email: string;
    id: number;
    profile: string | null;
  };
}

export interface IReplyResponse {
  attachment: string;
  content: string;
  edited: string;
  id: number;
  parent: number | null;
  posted: string;
  replies: [];
  reply_count: number;
  urlhash: string;
  user: {
    email: string;
    id: number;
    profile: string | null;
  };
}
export interface IAttachmentResponse {
  attachment: [
    {
      attachment: {
        name: string;
        type: string;
        url: string;
      };
    }
  ];
}

const fetchAttachmentList = (sessionId: string, routineId: string) => async () => {
  const { data } = await httpClient.get<IAttachmentResponse[]>(
    api.discussion.attachment.replace('{sessionId}', sessionId).replace('{routineId}', routineId)
  );

  return data;
};
const useAttachmentListQuery = (sessionId: string, routineId: string): any => {
  return useQuery([api.discussion.attachment], fetchAttachmentList(sessionId, routineId), {
    keepPreviousData: false,
    cacheTime: 0,
    onSuccess: (response: AxiosResponse) => {
      console.log(response);
    },
    onError: (error: AxiosError) => {
      console.log(error);
    }
  });
};

const fetchDiscussionList =
  ({
    sessionId,
    courseTitle,
    routineId
  }: {
    sessionId: string;
    courseTitle: string;
    routineId: string;
  }) =>
  async () => {
    const { data } = await httpClient.get<IDiscussionResponse[]>(
      api.discussion.fetch
        .replace('{courseTopic}', courseTitle)
        .replace('{sessionId}', sessionId)
        .replace('{routineId}', routineId)
    );

    return data;
  };

const saveDiscussion = (data: IDiscussionData) => {
  return httpClient.post<IDiscussionResponse>(
    api.discussion.save
      .replace('{courseTopic}', data.courseTitle)
      .replace('{sessionId}', data.sessionId),
    data.discussionDetail
  );
};

const saveDiscussionReply = (data: IDiscussionReplyData) => {
  return httpClient.post<IDiscussionResponse>(
    api.discussion.reply.save
      .replace('{courseTopic}', data.courseTitle)
      .replace('{parentId}', data.parentId.toString())
      .replace('{sessionId}', data.sessionId),
    data.replyDetail
  );
};

const useSaveDiscussionReplyMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(saveDiscussionReply, {
    onSuccess: () => {
      queryClient.refetchQueries(api.discussion.fetch);
      toast.success('Successfully added');
    },
    onError: () => {
      toast.error('Dissussion  failed !');
    }
  });
};

const useSaveDiscussionMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(saveDiscussion, {
    onSuccess: () => {
      queryClient.refetchQueries(api.discussion.fetch);
      toast.success('Successfully added');
    },
    onError: () => {
      toast.error('Dissussion  failed !');
    }
  });
};

const useDiscussionListQuery = (sessionId: string, courseTitle: string, routineId: string): any => {
  return useQuery(
    [api.discussion.fetch],
    fetchDiscussionList({ sessionId, courseTitle, routineId }),
    {
      keepPreviousData: false,
      cacheTime: 0,
      onSuccess: (response: AxiosResponse) => {
        console.log(response);
      },
      onError: (error: AxiosError) => {
        console.log(error);
      }
    }
  );
};

export {
  useAttachmentListQuery,
  useDiscussionListQuery,
  useSaveDiscussionMutation,
  useSaveDiscussionReplyMutation
};
